import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private ContactPersonSettings Types */
import {
  Settings,
  _ContactPersonSettings
} from '../namespace-helper'

import _ from 'lodash'

const selectedContactPersonTemplate = {
  id: 0,
  salution: null,
  title: null,
  firstname: 'Firstname',
  lastname: 'Lastname',
  email: null,
  phone: null,
  fax: null,
  mobile: null,
  main_contact: false,
  contacts_functions_id: null,
  suppliers_branch_offices_id: null
}

export default {
  namespaced: true,
  state: {
    contactPersons: [],
    contactPersonsForSupplierId: [],
    selectedContactPerson: _.cloneDeep(selectedContactPersonTemplate),
    contactPersonHasManufacturers: []
  },
  mutations: {
    [_ContactPersonSettings.mutations.setContactPersons] (state, payload) {
      state.contactPersons = payload
    },
    [_ContactPersonSettings.mutations.setContactPersonsForSupplier] (state, payload) {
      state.contactPersonsForSupplierId = payload
    },
    [_ContactPersonSettings.mutations.setSelectedContactPerson] (state, payload) {
      if (payload !== null) {
        state.selectedContactPerson = payload
      } else {
        state.selectedContactPerson = _.cloneDeep(selectedContactPersonTemplate)
      }
    },
    [_ContactPersonSettings.mutations.removeContactPerson] (state, payload) {
      state.contactPersons.splice(payload, 1)
    },
    [_ContactPersonSettings.mutations.addNewContactPerson] (state, payload) {
      if (state.contactPersons === null) {
        state.contactPersons = []
      }
      state.contactPersons.push(payload)
    },
    [_ContactPersonSettings.mutations.setContactPersonHasManufacturers] (state, payload) {
      state.contactPersonHasManufacturers = payload
    }
  },
  actions: {
    [_ContactPersonSettings.actions.saveContactPerson] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === null) {
          var url = API_URL + '/api/v1/supplierContacts'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/supplierContacts/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_ContactPersonSettings.actions.loadContactPersons] (context, payload) {
      console.log('loadContactPersons for branchOfficeID: ' + payload)

      var url = API_URL + '/api/v1/supplierContacts/branchOffice/' + payload

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_ContactPersonSettings.mutations.setContactPersons, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ContactPersonSettings.actions.loadContactPersonsBySupplierId] (context, payload) {
      console.log('loadContactPersonsBySupplierId for id: ' + payload)

      var url = API_URL + '/api/v1/supplierContacts/supplier/' + payload

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_ContactPersonSettings.mutations.setContactPersonsForSupplier, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },

    [_ContactPersonSettings.actions.setSelectedContactPerson] ({ commit }, payload) {
      commit(_ContactPersonSettings.mutations.setSelectedContactPerson, payload)
    },
    [_ContactPersonSettings.actions.setContactPersons] ({ commit }, payload) {
      commit(_ContactPersonSettings.mutations.setContactPersons, payload)
    },
    [_ContactPersonSettings.actions.addNewContactPerson] ({ commit }, payload) {
      commit(_ContactPersonSettings.mutations.addNewContactPerson, payload)
    },
    [_ContactPersonSettings.actions.removeContactPerson] (context, payload) {
      const tempBranchOfficesContacts = context.getters.getContactPersons
      const id = tempBranchOfficesContacts[payload].id

      if (id === null) {
        context.commit(_ContactPersonSettings.mutations.removeContactPerson, payload)
        return
      }

      var url = API_URL + '/api/v1/supplierContacts/' + id

      console.log('removeContactPerson: ' + id)

      store.commit(Settings.mutations.setLoading, false)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_ContactPersonSettings.mutations.removeContactPerson, payload)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_ContactPersonSettings.actions.loadContactPersonHasManufacturers] (context, payload) {
      console.log('loadContactPersonHasManufacturers: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/supplierContactHasManufacturers/' + payload

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_ContactPersonSettings.mutations.setContactPersonHasManufacturers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ContactPersonSettings.actions.saveSupplierContactHasManufacturers] (context, payload) {
      console.log('saveSupplierContactHasManufacturers: ' + JSON.stringify(payload))

      store.commit(Settings.mutations.setLoading, true)

      // Delete all mappings first
      var url = API_URL + '/api/v1/supplierContactHasManufacturers/' + payload.contact_person_id

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))

      // Save all mappings then
      url = API_URL + '/api/v1/supplierContactHasManufacturers'

      payload.supplier_contact_has_manufacturers.forEach(function (element) {
        const data = JSON.stringify(element)
        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ContactPersonSettings.actions.resetState] ({ commit }, payload) {
      commit(_ContactPersonSettings.mutations.setContactPersons, [])
      commit(_ContactPersonSettings.mutations.setContactPersonsForSupplier, [])
      commit(_ContactPersonSettings.mutations.setSelectedContactPerson, null)
      commit(_ContactPersonSettings.mutations.setContactPersonHasManufacturers, [])
    }
  },
  getters: {
    [_ContactPersonSettings.getters.getContactPersons] (state) {
      return state.contactPersons
    },
    [_ContactPersonSettings.getters.getContactPersonsForSupplierId] (state) {
      return state.contactPersonsForSupplierId
    },
    [_ContactPersonSettings.getters.getSelectedContactPerson] (state) {
      return state.selectedContactPerson
    },
    [_ContactPersonSettings.getters.getContactPersonsHasManufactures] (state) {
      return state.contactPersonHasManufacturers
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Settings/contactPersons.js